import { formatGetHeaders } from '@configurations/api-configuration';
import { UserRolesGateway } from '@scenario/gateways/user-roles.gateway';
import { UserRoles } from '@scenario/models/user-roles.model';
import { environment } from '../../../../../environments/environment';
import { UserRolesMapper } from './user-roles.mapper';

export class ApiUserRolesGateway implements UserRolesGateway {
  private readonly mapper = new UserRolesMapper();
  private readonly userRolesApi = `${environment.backend_url}/api/v1/user/roles`;

  async retrieve(): Promise<UserRoles> {
    try {
      const response = await fetch(`${this.userRolesApi}`, await formatGetHeaders());
      const data = await response.json();
      return this.mapper.mapToDomainModel(data);
    } catch (error) {
      throw new Error('Error retrieving user roles: ' + error);
    }
  }
}
